import { useMemo } from 'react'

/**
 * 处理markdown文本内容的换行符转换
 * @param rawText - 原始文本内容（包含 \n 转义字符）
 * @returns 处理后的文本内容
 */
export const useMarkdownTextProcessor = (rawText: string) => {
  const processedText = useMemo(() => {
    if (!rawText) return ''

    // 第一步：将字面量的 "\n" 转换为真正的换行符
    let text = rawText.replace(/\\n/g, '\n')

    // 第二步：处理双换行，在 textarea 中显示为段落间距
    // 保持双换行作为段落分隔
    text = text.replace(/\n\n/g, '\n\n')

    return text
  }, [rawText])

  return processedText
}
